import React from "react";
import "./notFound.css";

export default function NotFound() {
  return (
    <div className="not-found-container">
      <div className="not-found-box">
        <h1 className="not-found-header">404</h1>
        <p className="not-found-text">صفحه مورد نظر یافت نشد</p>
      </div>
    </div>
  );
}
